import { createFileRoute } from '@tanstack/react-router'
import { guardAdminOnly } from '@/lib/auth/routeGuards'
import { GradeManagement } from '@/components/adminPage/etablissment/GradeManagement'

export const Route = createFileRoute('/admin/grade')({
  component: GradeManagementRoute,
  beforeLoad: guardAdminOnly,
})

function GradeManagementRoute() {
  return (
    <div className="container mx-auto py-6">
      <GradeManagement />
    </div>
  )
}
